import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {StorageService} from "@portal/shared/services/storage.service";
import {AuthService} from "../../../../../core/auth/auth.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {GenericDialogComponent} from "@portal/shared/generic-dialog/generic-dialog.component";
import {CatalogProductsService} from "@portal/api/catalog-products.service";

@Component({
    selector: 'app-quote-request',
    templateUrl: './quote-request.component.html',
    styleUrls: ['./quote-request.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class QuoteRequestComponent implements OnInit {
    isSubmitting = false;
    quoteItems = [];
    formData = {
        name: '',
        email: '',
        phone: '',
        message: ''
    };

    constructor(
        private _storageService: StorageService,
        private authService: AuthService,
        private router: Router,
        private dialog: MatDialog,
        private _catalogProductsService: CatalogProductsService
    ) {
    }

    ngOnInit(): void {
        this.quoteItems = this._storageService.getQuoteItems();
        if (this.quoteItems.length === 0) {
            this.router.navigate(['/product-catalog']);
        }
    }

    isLoggedIn(): boolean {
        return !!this.authService.isAuthenticated;
    }

    submitQuote(): void {

        this.isSubmitting = true;

        const payload = {
            products: this.quoteItems,
            ...this.formData
        };

        this._catalogProductsService.quoteCatalog(payload).subscribe(
            {
                next: () => {
                    this.isSubmitting = false;
                    this._storageService.clearQuoteItems();

                    this.dialog.open(GenericDialogComponent, {
                        width: '400px',
                        data: {
                            title: 'Pedido enviado com sucesso!',
                            message: 'Obrigado pelo seu pedido de orçamento. Entraremos em contacto o mais breve possível.',
                            confirmText: 'Voltar ao catálogo'
                        }
                    }).afterClosed().subscribe(result => {
                        if (result === 'confirm') {
                            this.router.navigate(['/product-catalog']);
                        }
                    });
                },
                error: () => {
                    this.isSubmitting = false;
                    this.dialog.open(GenericDialogComponent, {
                        width: '400px',
                        data: {
                            title: 'Ocorreu um erro',
                            message: 'Por favor tente de novo ou envie um email para suporte@organiza360.pt!',
                            confirmText: 'Ok'
                        }
                    });
                }
            });
    }
}
